<div class="immo-task-header">
  <span class="title"
    >Taak: aanvraagdatum {{ createdAtDateTime | date: 'dd/MM/yyyy' }}
  </span>
  <span class="normal">{{ createdAtDateTime | date: 'HH:mm' }}</span>
  <div class="small-upper-space strong">
    <span>{{ name }}</span>
    <span *ngIf="phoneNumber?.length > 0" class="preserve-span-space">
      -
      <a class="click-link" href="tel:{{ phoneNumber }}">{{
        phoneNumber | asFormatPhoneNumber
      }}</a>
    </span>
    <span *ngIf="mobileNumber?.length > 0" class="preserve-span-space">
      -
      <a class="click-link" href="tel:{{ mobileNumber }}">{{
        mobileNumber | asFormatPhoneNumber
      }}</a>
    </span>
    <span *ngIf="email?.length > 0" class="preserve-span-space">
      - <a class="click-link" href="mailto:{{ email }}">{{ email }}</a>
    </span>
  </div>
</div>
